export const MAX_PRICE = 1000000;

export const TYPE_STAT = "stat";
